import React, { useEffect, useState } from "react";
import SpreadsheetViewerComponent from "../../components/SpreadsheetViewerComponent";
import axios from "axios";
import LoadingBackdrop from "../../components/common/LoadingBackdrop";
import { getConfig } from "../../AppConfig";
import {useParams} from "react-router";

interface Params {
    driveid: string
    woid: string
}
const SpreadsheetPage = () => {
    const { secretkey } = getConfig()
    const { driveid, woid } = useParams<Params>()
    const encriptedString = localStorage.getItem('pdfopen-' + driveid + '-' + woid)
    var CryptoJS = require("crypto-js");
    var bytes = CryptoJS.AES.decrypt(decodeURIComponent(encriptedString), secretkey);
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

    const [loadingBackdrop, setLoadingBackdrop] = React.useState(false)
    const [spreadsheetDataURL, setSpreadsheetDataURL] = React.useState(null)
    const [dialogMsg, setDialogMsg] = React.useState('');

    useEffect(() => {
        previewDoc()
    }, [decryptedData?.driveid])

    const previewDoc = () => {
        setLoadingBackdrop(true)
        var body = {}

        if (decryptedData?.driveid && decryptedData?.driveid?.length > 0) {
            body['id'] = decryptedData?.driveid
        }

        axios.post(`api/documentsfile`, body).then((response) => {
            const dataJson = JSON.parse(response.data.jsonString)
            if (dataJson?.status == 'failure') {
                // setDialogMsg(dataJson?.message)
            }
            else {
                var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                if (dataJson.fileext === 'xlsx') {
                    contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                } else if (dataJson.fileext === 'xls') {
                    contentType = 'application/vnd.ms-excel'
                } else if (dataJson.fileext === 'csv') {
                    contentType = 'text/csv'
                }

                const byteCharacters = atob(dataJson.filedata)
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: contentType });
                const url = window.URL.createObjectURL(blob);
                setSpreadsheetDataURL(url);
            }
            setLoadingBackdrop(false)
        }).catch(error => {
            setSpreadsheetDataURL('preview mode');
            setLoadingBackdrop(false)
        })
    }

    const saveDocumentCallback = (documentItem) => {
        setLoadingBackdrop(true)

        var body = {
            filedata: documentItem.imageData,
            GUID: '',
        }
        if (decryptedData?.woid > 0) {
            body['woid'] = decryptedData?.woid
        }
        if (decryptedData?.mimetype?.length > 0) {
            body['mimetype'] = decryptedData?.mimetype
        }
        if (decryptedData?.filename?.length > 0) {
            body['filename'] = decryptedData?.filename
        }
        if (typeof decryptedData?.issaveasbuilt == "boolean") {
            body['IsSaveAsBuilt'] = decryptedData?.issaveasbuilt
        }
        if (decryptedData?.driveid && decryptedData?.driveid?.length > 0) {
            body['id'] = decryptedData?.driveid
        }
        if (decryptedData?.generalformsid > 0) {
            body['generalformsid'] = decryptedData?.generalformsid
        }

        axios.put(`api/documentsfileoverwrite`, body).then((response) => {
            const data = JSON.parse(response.data.jsonString)
            documentItem.setLoadingBackdrop(false)
            setLoadingBackdrop(false)
            if (data.status == 'failure') {
                setDialogMsg(data.message)
            }
            else if (data.status == "success") {
                setDialogMsg(data?.message?.length > 0 ? data.message : "Successfully Saved")
            }
        }).catch(error => {
            if (error.response) {
                setDialogMsg(error?.response?.data?.title)
            } else if (error.request) {
                setDialogMsg(error.request)
            } else {
                setDialogMsg(error.message)
            }
            documentItem.setLoadingBackdrop(false)
            setLoadingBackdrop(false)
        })
    }

    const closeDialog = () => {
        setDialogMsg("")
    }

    return (
        <>
            {spreadsheetDataURL != null &&
                <SpreadsheetViewerComponent
                    save={decryptedData?.save}
                    item={{ allowsave: decryptedData?.save }}
                    woid={decryptedData?.woid}
                    readonly={decryptedData?.readonly}
                    filename={decryptedData.filename}
                    saveDocumentCallback={saveDocumentCallback}
                    // generalformsgoogledriveid={decryptedData?.driveid}
                    document={spreadsheetDataURL}
                    // decryptedData={decryptedData}
                />
            }
            <LoadingBackdrop open={loadingBackdrop} />
        </>
    );
}

export default SpreadsheetPage
